import FormattedMessage from 'I18n/components/FormattedMessage';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import { jsx as _jsx } from "react/jsx-runtime";
export const showSubtopicLimitReachedError = () => {
  FloatingAlertStore.addAlert({
    type: 'warning',
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.topicEditor.errors.subtopicLimitReached.title"
    }),
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.topicEditor.errors.subtopicLimitReached.message"
    })
  });
};